import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      OF: "av",
      PREVIOUS: "forrige side",
      NEXT: "neste side",
    },
    se: {
      OF: "av",
      PREVIOUS: "föregående sida",
      NEXT: "nästa sida",
    },
    dk: {
      OF: "af",
      PREVIOUS: "forrige side",
      NEXT: "næste side",
    },
  } as const
)[language];
